import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  color: theme.palette.secondary.main,
  backgroundColor: theme.palette.common.white,
  '& .VMsecDark': {
    color: theme.palette.secondary.dark,
  },
}));

export default StyledBox;
